import React from 'react';
const SvgSheetThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 1024 1024" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M112.6 30.7v962.6h798.7V235.5H706.6V30.7h-594z" />
      <path fill="#FFF" d="M153.6 81.9h553v153.6h163.8v512H153.6V81.9z" />
      <path fill="#769CC2" d="M706.6 30.7l204.8 204.8H706.6V30.7z" />
      <path opacity={0.3} fill="#1B3F63" d="M706.6 235.5h204.8v204.8L706.6 235.5z" />
      <g>
        <path
          fill="#5C7896"
          d="M752 235.5V543h-64v-24h-30v89h30v-34.7h83.9v-.3H782V235.5h-30zM505 543H272V408h60v-30h-60V236h213v142h-56v30h86V236h191.6v-30H242v367h263v35h30v-89h-30v24z"
          opacity={0.9}
        />
      </g>
    </svg>
  );
});
export default SvgSheetThumbnail;
SvgSheetThumbnail.iconName = 'sheet-thumbnail';
SvgSheetThumbnail.displayName = 'SvgSheetThumbnail';
